module.exports = __webpack_public_path__ + "img/autonomousvehicle.0ca3fa30.png";